import { signInWithCustomToken } from 'firebase/auth'
import { httpsCallable } from 'firebase/functions'
import type { TestAccount } from '@sonder/shared'
import { auth, functions } from '@/lib/firebase'

/** A real person by uid, or one of the built-in test accounts (created on first use). */
export type SignInTarget = { targetUid: string } | { test: TestAccount }

/**
 * Switch the session to someone else (admins only; the server checks) or back. Each ends in a full page load so every
 * listener, cache-backed query and preview state from the previous person is dropped, and Home routes the new one.
 */
export async function signInAs(target: SignInTarget, firstVisit: boolean): Promise<void> {
  const { data } = await httpsCallable<SignInTarget & { firstVisit: boolean }, { token: string }>(functions, 'startImpersonation')({ ...target, firstVisit })
  await signInWithCustomToken(auth, data.token)
  window.location.assign('/')
}

export async function returnToSelf(): Promise<void> {
  const { data } = await httpsCallable<void, { token: string }>(functions, 'endImpersonation')()
  await signInWithCustomToken(auth, data.token)
  window.location.assign('/staff')
}

/** A callable's message is already written for people; anything else gets a generic line. */
export function switchError(e: unknown): string {
  const msg = (e as { message?: string })?.message ?? ''
  return msg && msg !== 'internal' ? msg : 'Couldn’t switch accounts. Try again.'
}
